module.exports = __webpack_public_path__ + "img/slider_6.8fe28255.jpg";